import {Component, Inject, OnInit} from '@angular/core';
import { OrderCancellationService } from '../../services/order-cancellation.service';
import { ActivatedRoute } from '@angular/router';
import {OtherTemplatesService} from '../../../home/services/other-templates.service';
import {DOCUMENT} from '@angular/common';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-order-cancellation-confirmation',
  templateUrl: './order-cancellation-confirmation.component.html',
  styleUrls: ['./order-cancellation-confirmation.component.css'],
})
export class OrderCancellationConfirmationComponent implements OnInit {
  processing = true;
  confirmed = false;
  _currentLanguage;

  confirmationText = '';

  constructor(
    private orderCancellationService: OrderCancellationService,
    private route: ActivatedRoute,
    private templatesService: OtherTemplatesService,
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) {
    translate.onLangChange.subscribe((e: LangChangeEvent) => {
        this._currentLanguage = translate.currentLang;
        if (this.confirmed) {
          if (this._currentLanguage === 'de') {
            this.templatesService.getForView('cancellation_confirmation_de').subscribe(result => {
                this.confirmationText = result.html;
              },
              error => {
                this.confirmationText = '';
              });
          } else {
            this.templatesService.getForView('cancellation_confirmation_en').subscribe(result => {
                this.confirmationText = result.html;
              },
              error => {
                this.confirmationText = '';
              });
          }
        }
      }
    );
    this._currentLanguage = translate.currentLang;
  }



  ngOnInit() {
    const token =  this.route.snapshot.queryParamMap.get('token');
    this.orderCancellationService.confirmCancellationByEmail(token).subscribe(result => {
      this.confirmed = true;
      if( this._currentLanguage === 'de' ) {
        this.templatesService.getForView('cancellation_confirmation_de').subscribe(result => {
          this.confirmationText = result.html;
          this.processing = false;
        },
          error => {
            this.processing = false;
          });
      }else{
        this.templatesService.getForView('cancellation_confirmation_en').subscribe(result => {
          this.confirmationText = result.html;
          this.processing = false;
        },
          error => {
            this.processing = false;
          });
      }

    }, error => {
      this.confirmed = false;
      this.processing = false;
    });
  }

}
